export { comingSoonPage as default } from '../common/userData/UserKycStatus';
